"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  padding: 0;\n  border: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Element = _styledComponents.default.fieldset(_templateObject());

var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return /*#__PURE__*/_react.default.createElement(Element, props, children);
};

Fieldset.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Fieldset;
exports.default = _default;